/* eslint-disable */
import { CONFIG } from "~/config";
import { frpc } from "../general";

const URL = "/altitude";
const TIMEOUT = 60 * 1000; // [s]

let profileCache = [];

interface IAltitudeResponseItemData {
	lat: number,
	lon: number,
	alt: number,
}

interface IAltitudeResponse {
	status: number,
	statusMessage: string,
	data: {
		gain: number,
		length: number,
		loss: number,
		max: number,
		min: number,
		data: Array<IAltitudeResponseItemData>
	}
}

/**
 * Ziskani dat pro vyskovy profil.
 *
 * @param {String} coords Zasifrovane souradnice na string
 * @param {Object} [opts]
 * @param {Object} [opts.count=100] Pocet bodu k namapovani
 * @return {Object}
 */
export function altitudeProfile(coords: string, opts: {
	count: number,
} = {
	count: 100,
}): {
	promise: Promise<IAltitudeResponse>,
	request: any,
} {
	let args = [coords, opts];
	let params = JSON.stringify(args);

	// projdeme kes
	let now = Date.now();
	let frpcData = null;

	for (let i = profileCache.length - 1; i >= 0; i--) {
		if (now > profileCache[i].time) {
			profileCache.splice(i, 1);
		}
		else if (profileCache[i].params == params) {
			frpcData = profileCache[i].frpcData;
		}
	}

	// request + ulozeni do kese
	if (!frpcData) {
		frpcData = frpc({
			url: CONFIG.requestUrl + URL,
			method: "profile",
			args,
		});

		profileCache.push({
			params,
			frpcData,
			time: now + TIMEOUT
		});
	}

	return frpcData;
};
